var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.207 8.778a.523.523 0 0 1-.37-.154L4.464 5.211 1.163 8.622a.517.517 0 0 1-.742 0C.323 8.522.27 8.391.27 8.25s.054-.273.153-.373l3.373-3.412L.422 1.122a.532.532 0 0 1 0-.745.517.517 0 0 1 .741 0l3.373 3.412L7.837.377c.098-.1.229-.155.37-.155s.271.055.369.154c.1.1.154.232.154.374s-.054.274-.153.373L5.204 4.535l3.373 3.344a.528.528 0 0 1-.37.899z"
  })));
};
export default SvgClose;